import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
} from '@mui/material';
import {
  SwapHoriz as TransferIcon,
  School as CMI5Icon,
} from '@mui/icons-material';
import { TransferManager } from './TransferManager';
import { CMI5ActivityBrowser } from './CMI5ActivityBrowser';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`moodle-tabpanel-${index}`}
      aria-labelledby={`moodle-tab-${index}`}
      style={{ height: '100%' }}
      {...other}
    >
      {value === index && (
        <Box sx={{ height: '100%' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

interface MoodleContentManagerProps {
  currentEnvironment: string;
}

export const MoodleContentManager: React.FC<MoodleContentManagerProps> = ({ currentEnvironment }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Sub-tabs header */}
      <Box sx={{
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        px: 2,
      }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          sx={{ minHeight: 48 }}
        >
          <Tab
            label="Transfer Manager"
            icon={<TransferIcon />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          <Tab
            label="CMI5 Browser"
            icon={<CMI5Icon />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
        </Tabs>
      </Box>

      {/* Tab content */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <TabPanel value={activeTab} index={0}>
          <TransferManager
            currentEnvironment={currentEnvironment}
            onBackToS3Manager={() => {
              // No-op since we're in a tabbed view
            }}
          />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <CMI5ActivityBrowser
            onBack={() => {
              // No-op since we're in a tabbed view
            }}
          />
        </TabPanel>
      </Box>
    </Box>
  );
};
